import React, {FC, useMemo} from "react";
import {useIntl} from "react-intl";

import {activityStore} from "../../../../../store/activity.store";
import { Button } from "../../../../ui/button";
import { Spin } from "../../../../ui/spinner";
import { Empty } from "../../../../ui/empty";
import DaysIntervals from "../DaysIntervals/DaysIntervals";

const HistoryList: FC = () => {
  const { formatMessage } = useIntl();

  const daysIntervals = activityStore(state => state.daysIntervals || []);
  const getIntervalsStartPageLoading = activityStore(state => state.loading.getIntervalsStartPage);
  const getNextIntervalsPageLoading = activityStore(state => state.loading.getNextIntervalsPage);
  const isLast = activityStore(state => state.intervalsPaginationInfo.last);
  const getNextIntervalsStartPage = activityStore(state => state.getNextIntervalsPage);
  const intervalsParams = activityStore(state => state.intervalsParams);
  const filtersConfiguration = activityStore(state => state.filtersConfiguration);

  const hasFilters = useMemo(() => {
    return (intervalsParams.types && intervalsParams.types.length > 0) ||
           (intervalsParams.tags && intervalsParams.tags.length > 0) ||
           !!filtersConfiguration;
  }, [intervalsParams.types, intervalsParams.tags, filtersConfiguration]);

  const isEmpty = !getIntervalsStartPageLoading && daysIntervals.length === 0;

  return (
    <Spin spinning={getIntervalsStartPageLoading}>
      {isEmpty ? (
        <Empty
          description={
            hasFilters
              ? formatMessage({ id: 'NO_DATA_FOR_RANGE_AND_FILTERS' })
              : formatMessage({ id: 'NO_DATA_FOR_RANGE' })
          }
        />
      ) : (
        <>
          <div>
            {daysIntervals.map(dayIntervals => (
              <DaysIntervals key={dayIntervals.title} dayIntervals={dayIntervals} />
            ))}
          </div>
          {!isLast && !!daysIntervals?.length && (
            <div className="flex justify-center mt-4">
              <Button
                variant="outline"
                loading={getNextIntervalsPageLoading}
                onClick={getNextIntervalsStartPage}
              >
                {formatMessage({ id: 'LOAD_MORE'})}
              </Button>
            </div>
          )}
        </>
      )}
    </Spin>
  );
}

export default HistoryList;
